/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Clients_AInputs */

const en_platform_faq_clients_a = /** @type {(inputs: Platform_Faq_Clients_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. They book from your page in a browser. If they want their plan, their progress and their bookings in one place, there is an app, but nothing needs it.`)
};

const pl_platform_faq_clients_a = /** @type {(inputs: Platform_Faq_Clients_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie. Rezerwują z Twojej strony w przeglądarce. Jeśli chcą mieć plan, postępy i rezerwacje w jednym miejscu, jest aplikacja, ale nic jej nie wymaga.`)
};

/**
* | output |
* | --- |
* | "No. They book from your page in a browser. If they want their plan, their progress and their bookings in one place, there is an app, but nothing needs it." |
*
* @param {Platform_Faq_Clients_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_clients_a = /** @type {((inputs?: Platform_Faq_Clients_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Clients_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_clients_a(inputs)
	return en_platform_faq_clients_a(inputs)
});